import { compose } from 'redux';
import connectWithConditionFactory from '@Hooks/connectWithConditionFactory';

import { withLaptopBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';
import {
  onHeatmapButtonClick as onHeatmapButtonClickAction,
  openDialog as openHeatmapSettingsDialogAction,
} from '@Pages/Heatmap/HeatmapSettingsDialog/actions';
import { activeBreadCrumbContext, activeBreadcrumbForDb } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import { isHeatmapAvailable, fullScreenMode as heatmapFullScreenModeIndicator } from '@Pages/Heatmap/selectors';
import { sortingProperties, currentSortingPropertiesBySortValue } from '@Containers/SortingProperties/SortingPropertiesSelectors';
import { sort, order, context, hitSetKey } from '@Selectors/StateParamsSelectors';
import { open as filtersOpened } from '@Containers/ResultsFilters/ResultsFiltersSelectors';
import { chemquoteEnabled } from '@Containers/UserDetails/UserDetailsSelectors';
import { recordCountOrTotalResult } from '@Containers/PatentFamilyClustering/selectors';

import {
  isTgitemsContext,
  isReactionsContext,
  isCitationsContext,
  isSubstancesContext,
  availableRelativeContext,
  isHeatmapContextPresent,
} from './ResultToolbarSelectors';
import { setSorting } from './ResultToolbarActions';
import ResultToolbar from './ResultToolbar';

function mapStateToProps(state) {
  return {
    sort: sort(state),
    order: order(state),
    context: context(state),
    filtersOpened: filtersOpened(state),
    chemquoteEnabled: chemquoteEnabled(state),
    isTgitemsContext: isTgitemsContext(state),
    activeBreadCrumb: activeBreadcrumbForDb(state),
    sortingProperties: sortingProperties(state),
    isHeatmapAvailable: isHeatmapAvailable(state),
    isHeatmapDisabled: !isHeatmapContextPresent(state, { hitSetKey: hitSetKey(state) }),
    isReactionsContext: isReactionsContext(state),
    isCitationsContext: isCitationsContext(state),
    isSubstancesContext: isSubstancesContext(state),
    currentSortingPropertiesBySortValue: currentSortingPropertiesBySortValue(state),
    // TODO check and remove getting openHeatmapIndicator from state
    // openHeatmapIndicator: openHeatmapIndicator(state),
    activeBreadCrumbContext: activeBreadCrumbContext(state),
    availableRelativeContext: availableRelativeContext(state, { hitSetKey: hitSetKey(state) }),
    totalResult: recordCountOrTotalResult(state),
    heatmapFullScreenModeIndicator: heatmapFullScreenModeIndicator(state),
  };
}

const mapDispatchToProps = {
  setSorting,
  onHeatmapButtonClick: onHeatmapButtonClickAction,
  openHeatmapSettingsDialog: openHeatmapSettingsDialogAction,
};

const resultToolbarConnect = connectWithConditionFactory((state, ownProps) => {
  const ctx = context(state);
  const breadCrumbContext = activeBreadCrumbContext(state);
  // TODO check and remove getting openHeatmapIndicator from state
  const isHeatmapOpened = ownProps.openHeatmapIndicator;

  if (isHeatmapOpened) {
    return true;
  }

  return ctx && ctx === breadCrumbContext;
});

export default compose(resultToolbarConnect(mapStateToProps, mapDispatchToProps), withLaptopBreakpoint())(ResultToolbar);
